/* global ReactOnRails */
import { DEFAULT_PAGE_SIZE } from 'appConstants'
import { withTrackedRoot } from 'lib/scoped_react_roots'

export function registerContext (ctx) {
  const components = {}
  ctx.keys().forEach((filename) => {
    const name = filename.replace(/^\.\//, '').replace(/(\.(js))?\.jsx$/, '')
    if (ctx(filename).default) components[name] = withTrackedRoot(ctx(filename).default)
  })
  ReactOnRails.register(components)
}

// For deprecated browsers
function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  let successful = false
  try {
    successful = document.execCommand('copy')
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
  return successful
}

// Resolves to true/false rather than rejecting, so callers that don't
// await the result (fire-and-forget) never trigger an unhandled rejection.
export function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    return Promise.resolve(fallbackCopyTextToClipboard(text))
  }
  return navigator.clipboard.writeText(text).then(
    () => true,
    (err) => {
      console.error('Async: Could not copy text: ', err)
      return false
    }
  )
}

/**
 * @param {array} array
 * @param {string | number} id
 * @returns {object}
 */
export function getElementById (array, id) {
  return array.find(item => item.id === id)
}

/**
 * @param {array} array
 * @param {string | number} id
 * @returns {array}
 */
export function removeElementById (array, id) {
  const objWithIdIndex = array.findIndex((obj) => obj.id === id)

  if (objWithIdIndex > -1) {
    array.splice(objWithIdIndex, 1)
  }

  return array
}

/**
 * Bake pagination params from saved backend pagination data
 *
 * @param {object} paginator
 * @returns {object} contains:
 * defaultPageSize {number} - saved on backend side Page Size
 * pagingSizes {number[]} - Array of Page Size options
 */
export function bakePagination (paginator) {
  const defaultPageSize = paginator?.perPage?.current || DEFAULT_PAGE_SIZE
  const pagingSizes = Object.keys(paginator?.perPage?.options || {})

  return { defaultPageSize, pagingSizes }
}

/**
 * Returns all "GET" parameters from the current page URL
 *
 * @param {array} params
 * @returns {object}
 */
export function getUrlParams (params) {
  const searchParams = new URLSearchParams(window.location.search)
  const result = {}

  for (const param of params) {
    const method = (param.endsWith('[]')) ? 'getAll' : 'get'
    result[param] = searchParams[method](param)
  }

  return result
}

const optionHtmlCache = new Map()

export function optionHtml (label) {
  let html = optionHtmlCache.get(label)
  if (!html) {
    html = { __html: label }
    optionHtmlCache.set(label, html)
  }
  return html
}
